import { DAY_KEYS, type DayKey } from "@/lib/days";
import type { MealDiaryConfig, MealDiaryDayData } from "@/lib/schema";

// Reads Måltider ferdig from the week row, never the meals themselves: every
// scoring path in the app scores synchronously from the snapshot
// (docs/adr/0028). The widget keeps the marker false on a day with no meals,
// so "finished" alone is the whole rule.
export function scoreDay(config: MealDiaryConfig, dayData: unknown): number {
  const data = (dayData ?? {}) as MealDiaryDayData;
  return data.finished === true ? config.points : 0;
}

export function scoreWeek(
  config: MealDiaryConfig,
  runtime: { week: unknown; days: Record<DayKey, unknown> },
): number {
  let total = 0;
  for (const k of DAY_KEYS) total += scoreDay(config, runtime.days[k]);
  return total;
}

export function maxScoreWeek(config: MealDiaryConfig): number {
  return 7 * config.points;
}
